import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';

// Global stiller — :root token tanımları + reset + tipografi (CSS modüllerinden ÖNCE yüklenmeli)
import './shared/styles/reset.css';
import './shared/styles/tokens.css';
import './shared/styles/typography.css';
import './shared/styles/animations.css';
import './shared/styles/utilities.css';

import { AuthGuard } from './app/AuthGuard';
import { ErrorBoundary } from './app/ErrorBoundary';
import { B2bOnlyRoute, HomeRoute } from './app/OrgRouteGate';
import { QueryProvider } from './app/QueryProvider';
import { ApiKeysPage } from './features/api-keys/pages/ApiKeysPage';
import { AuditPage } from './features/audit/pages/AuditPage';

// Auth pages
import { Login } from './features/auth/pages/Login';
import { Register } from './features/auth/pages/Register';
import { BillingPage } from './features/billing/pages/BillingPage';
import { BrandedNumbersPage } from './features/branded/pages/BrandedNumbersPage';
import { CallsPage } from './features/calls/pages/CallsPage';
// Dashboard pages
import { Overview } from './features/dashboard/pages/Overview';
import { LivePage } from './features/live/pages/LivePage';
import { MembersPage } from './features/members/pages/MembersPage';
import { RecordingsPage } from './features/recordings/pages/RecordingsPage';
import { ReportsPage } from './features/reports/pages/ReportsPage';
import { SchoolPage } from './features/school/pages/SchoolPage';
import { SettingsPage } from './features/settings/pages/SettingsPage';
import { StaffPage } from './features/staff/pages/StaffPage';
import { StatusPage } from './features/status/pages/StatusPage';
import { WebhooksPage } from './features/webhooks/pages/WebhooksPage';
import { AppLayout } from './layouts/AppLayout';
import { AuthLayout } from './layouts/AuthLayout';

// Sentry başlat (P0-D)
import './shared/lib/observability/sentry';
// i18n başlat (render'dan önce hazır olmalı)
import './shared/lib/i18n';

const router = createBrowserRouter([
  {
    // Auth layout — Outlet üzerinden Login/Register render edilir
    path: '/login',
    element: <AuthLayout />,
    children: [{ index: true, element: <Login /> }],
  },
  {
    path: '/register',
    element: <AuthLayout />,
    children: [{ index: true, element: <Register /> }],
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      // Okul kademe 1: okul org'unda index /school'a düşer, B2B sayfaları kapalı
      // (Sidebar zaten gizler; bu kapılar URL ile doğrudan erişimi de keser).
      { index: true, element: <HomeRoute><Overview /></HomeRoute> },
      { path: 'live', element: <B2bOnlyRoute><LivePage /></B2bOnlyRoute> },
      { path: 'calls', element: <B2bOnlyRoute><CallsPage /></B2bOnlyRoute> },
      { path: 'recordings', element: <B2bOnlyRoute><RecordingsPage /></B2bOnlyRoute> },
      { path: 'staff', element: <StaffPage /> },
      { path: 'members', element: <B2bOnlyRoute><MembersPage /></B2bOnlyRoute> },
      { path: 'school', element: <SchoolPage /> },
      { path: 'branded', element: <B2bOnlyRoute><BrandedNumbersPage /></B2bOnlyRoute> },
      { path: 'reports', element: <ReportsPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'api-keys', element: <B2bOnlyRoute><ApiKeysPage /></B2bOnlyRoute> },
      { path: 'webhooks', element: <B2bOnlyRoute><WebhooksPage /></B2bOnlyRoute> },
      { path: 'billing', element: <BillingPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'status', element: <StatusPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

const root = document.getElementById('root');
if (!root) throw new Error('Root element bulunamadı');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <RouterProvider router={router} />
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>,
);
